<template>
  <div>
    <vue-range-slider v-model="model" v-bind="mergedOptions" class="space-mt-2">
      <template v-slot:knob>
        <span
          class="range-slider-knob__inner type-subtitle type-weight-700 position-absolute">{{ model }}°C</span>
      </template>
    </vue-range-slider>
    <span class="range-slider-min type-subtitle space-ml-1">{{ options.min }}°C</span>
    <span class="range-slider-max type-subtitle space-mr-1">{{ options.max }}°C</span>
  </div>
</template>

<script>
  import VueRangeSlider from 'vue-range-slider';
  import 'vue-range-slider/dist/vue-range-slider.css';

  export default {
    name: 'FormRange',
    components: {
      VueRangeSlider,
    },
    props: {
      options: {
        type: Object,
        required: true,
        default: () => {},
      },
      value: {
        type: [ String, Number ],
        required: true,
      },
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      mergedOptions() {
        return Object.assign({}, this.options);
      },
    },
  };
</script>

<style lang="scss">
$slider-rail-color: #ddd;

.range-slider {
  display: flex;
  width: 100%;
  height: 28px;
  background: c('grey');
  border-radius: 30px;
}

.range-slider-inner {
  width: 100%;
}

.range-slider-hidden {
  display: none;
}

.range-slider-min {
  float: left;
}

.range-slider-max {
  float: right;
}

.range-slider-knob {
  background: c('green');
  border: 0;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
}

.range-slider-knob__inner {
  bottom: space(4);
  margin-left: -12px;
}

.range-slider-rail {
  background: $slider-rail-color;
}

.range-slider-fill {
  background: c('green');
}

.range-slider-rail,
.range-slider-fill {
  height: 3px;
}
</style>
